<template>
  <a-card class="Question">
    <div class="searchForm" style="margin-bottom: 15px" @keyup.enter="getList(1)">
      <a-form-model layout="inline">
        <a-form-model-item label="题目名称">
          <a-input placeholder="请输入题目名称" :maxLength="35" v-model.trim="search.name" />
        </a-form-model-item>
        <a-form-model-item label="题目分组">
          <a-input placeholder="请输入题目分组" :maxLength="35" v-model.trim="search.questionGroup" />
        </a-form-model-item>
        <a-form-model-item label="能力维度">
          <a-cascader v-model="selectId" :options="options" :load-data="loadData" placeholder="请选择能力维度" change-on-select @change="onChange" />
        </a-form-model-item>
        <a-form-model-item label="题目类型">
          <a-select allowClear v-model="search.questionType" style="width: 180px" placeholder="请选择题目类型">
            <a-select-option :value="item.value" :key="item.value" v-for="item in questionTypeList">
              {{ item.title }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" @click="getList(1)">查询</a-button>
          <a-button style="margin: 0 35px 0 15px" @click="resetSearch()">重置</a-button>
        </a-form-model-item>
        <a-form-model-item>
          <a-button @click="addEgame()" type="primary" icon="plus" style="margin-right: 15px" v-permission="`/content/Question/QuestionSeting`">手动添加</a-button>
          <a-button @click="openModal()" type="primary" icon="import" style="margin-right: 15px" v-permission="`Content.Question.Import`">批量导入</a-button>
          <a-button @click="betchDel()" type="danger" icon="delete" v-permission="`Content.Question.Delete`">批量删除</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div>
      <a-table
        :loading="loading"
        :columns="columns"
        :data-source="dataSource"
        @expand="getVersion"
        class="components-table-demo-nested"
        rowKey="id"
        :rowSelection="rowSelection"
        :pagination="{
          current: search.pageIndex,
          pageSize: search.pageSize,
          total: total,
          showSizeChanger: true,
          showLessItems: true,
          showQuickJumper: true,
          showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条，总计 ${total} 条`,
          onChange: onPageChange,
          onShowSizeChange: onSizeChange,
        }"
      >
        <div slot="name" :ref="'titleName' + index" :title="record.name.replace(/\r|\n|(<[^>]+>)/g, '')" v-html="record.name" class="name" slot-scope="text, record, index"></div>
        <div slot="type" slot-scope="text, record">
          {{ $data._questionType[record.questionType] }}
        </div>
        <div slot="status" slot-scope="text, record" v-auth="`Content.Question.Enabled`">
          <a-switch checked-children="启用" un-checked-children="禁用" :checked="record.status" @click="StatusChange(record)" />
        </div>
        <div slot="action" slot-scope="text, record" class="action">
          <a @click="edit(record)" v-permission="`/content/Question/QuestionSeting`"> <a-icon type="edit" /> 编辑 </a>
          <a @click="preview(record)" v-permission="`Content.Question.Preview`"> <a-icon type="eye" /> 预览 </a>
          <a-popconfirm title="确认删除此题目" @confirm="delQuestion([record.id])">
            <a class="red" v-permission="`Content.Question.Delete`"> <a-icon type="delete" /> 删除 </a>
          </a-popconfirm>
        </div>
      </a-table>
    </div>
    <a-modal v-model="isimport" title="批量导入题目" @ok="submit">
      <template slot="footer">
        <a-button key="back" @click="cancelSubmit">取消</a-button>
        <a-button key="submit" type="primary" :loading="submitloading" @click="submit">确定</a-button>
      </template>
      <div class="um-download">
        <h4 class="um-h4">数据模板下载</h4>
        <p align="center">
          <a :href="DownloadTemplate | filterUrl" class="templateDownload">模板下载</a>
        </p>
      </div>
      <div class="um-download">
        <h4 class="um-h4">批量导入题目</h4>
      </div>
      <a-upload-dragger name="file" :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload" @change="unploadChange">
        <h4 class="um-upload">上传文件</h4>
        <p class="ant-upload-drag-icon">
          <a-icon type="cloud-upload" />
        </p>
        <p class="ant-upload-text" style="color: #666">点击上传文件，或将文件拖拽到此处</p>
        <p class="ant-upload-hint">（支持扩展名为xlsx文件）</p>
      </a-upload-dragger>
      <a @click="down()" v-if="errorData.length" style="text-align: center; margin: 20px 0; display: block; color: #f00">点击这里下载错误数据</a>
    </a-modal>
    <a-modal v-model="ispreview" title="题目预览" :footer="null" width="40%">
      <!-- 单选题 -->
      <div v-if="qusetionItem.questionType == 1">
        <div class="top">
          <span v-html="qusetionItem.name"></span>
          <img :src="qusetionItem.attachmentUrl | filterUrl" v-if="qusetionItem.attachmentUrl" />
        </div>
        <div class="bottom">
          <ul class="viewUl">
            <li v-for="item in qusetionItem.questionItems" :key="item.id">
              <a-radio disabled></a-radio>
              <span>{{ item.itemTitle }}</span>
              <img :src="item.itemAttachmentUrl | filterUrl" v-if="item.itemAttachmentUrl" />
              <a-icon type="check" v-if="item.isRightChoice" style="margin-left: 10px; font-size: 20px" />
            </li>
          </ul>
        </div>
      </div>
      <!-- 多选题 -->
      <div v-if="qusetionItem.questionType == 2">
        <div class="top">
          <span v-html="qusetionItem.name"></span>
          <img :src="qusetionItem.attachmentUrl | filterUrl" v-if="qusetionItem.attachmentUrl" />
        </div>
        <div class="bottom">
          <ul class="viewUl">
            <li v-for="item in qusetionItem.questionItems" :key="item.id">
              <a-checkbox disabled></a-checkbox>
              <span>{{ item.itemTitle }}</span>
              <img :src="item.itemAttachmentUrl | filterUrl" v-if="item.itemAttachmentUrl" />
              <a-icon type="check" v-if="item.isRightChoice" style="margin-left: 10px; font-size: 20px" />
            </li>
          </ul>
        </div>
      </div>
      <!-- 量表题 -->
      <div v-if="qusetionItem.questionType == 3">
        <div class="top">
          <span v-html="qusetionItem.name"></span>
          <img :src="qusetionItem.attachmentUrl | filterUrl" v-if="qusetionItem.attachmentUrl" />
        </div>
        <div class="bottom">
          <ul class="viewUl">
            <li v-for="item in qusetionItem.questionItems" :key="item.id">
              <a-radio disabled></a-radio>
              <span>{{ item.itemTitle }}</span>
              <img :src="item.itemAttachmentUrl | filterUrl" v-if="item.itemAttachmentUrl" />
              <a-icon type="check" v-if="item.isRightChoice" style="margin-left: 10px; font-size: 20px" />
            </li>
          </ul>
        </div>
      </div>
      <!-- 矩阵单选 -->
      <div v-if="qusetionItem.questionType == 4">
        <div class="top">
          <span v-html="qusetionItem.name"></span>
          <img :src="qusetionItem.attachmentUrl | filterUrl" v-if="qusetionItem.attachmentUrl" />
        </div>
        <div class="bottom">
          <ul class="viewUl">
            <div class="bot_t">
              <li></li>
              <template v-for="item in qusetionItem.questionItems">
                <li v-if="item.itemType == 0" :key="item.id" class="viewpick">
                  <span>{{ item.itemTitle }}</span>
                  <img :src="item.itemAttachmentUrl | filterUrl" v-if="item.itemAttachmentUrl" />
                  <!-- <a-icon type="check" v-if="item.isRightChoice" style="margin-left:10px;font-size:20px;"/> -->
                </li>
              </template>
            </div>
            <div class="bot_b">
              <template v-for="item in qusetionItem.questionItems">
                <li v-if="item.itemType == 1" :key="item.id">
                  <span>{{ item.itemTitle }}</span>
                  <span v-for="el in num"><a-radio disabled></a-radio></span>
                </li>
              </template>
            </div>
            <!-- <template v-for="item in qusetionItem.questionItems" >
              <li v-if="item.itemType == 1" :key="item.id">
                <span>{{item.itemTitle}}</span>
                <a-radio disabled></a-radio>
                <img :src="item.itemAttachmentUrl" v-if="item.itemAttachmentUrl">
                <a-icon type="check" v-if="item.isRightChoice" style="margin-left:10px;font-size:20px;"/>
              </li>
            </template> -->
          </ul>
        </div>
      </div>
      <!-- 矩阵多选 -->
      <div v-if="qusetionItem.questionType == 5">
        <div class="top">
          <span v-html="qusetionItem.name"></span>
          <img :src="qusetionItem.attachmentUrl | filterUrl" v-if="qusetionItem.attachmentUrl" />
        </div>
        <div class="bottom">
          <ul class="viewUl">
            <div class="bot_t">
              <li></li>
              <template v-for="item in qusetionItem.questionItems">
                <li v-if="item.itemType == 0" :key="item.id" class="viewpick">
                  <span>{{ item.itemTitle }}</span>
                  <img :src="item.itemAttachmentUrl | filterUrl" v-if="item.itemAttachmentUrl" />
                  <!-- <a-icon type="check" v-if="item.isRightChoice" style="margin-left:10px;font-size:20px;"/> -->
                </li>
              </template>
            </div>
            <div class="bot_b">
              <template v-for="item in qusetionItem.questionItems">
                <li v-if="item.itemType == 1" :key="item.id">
                  <span>{{ item.itemTitle }}</span>
                  <span v-for="el in num"><a-checkbox disabled></a-checkbox></span>
                </li>
              </template>
            </div>
          </ul>
        </div>
      </div>
      <!-- 矩阵量表 -->
      <div v-if="qusetionItem.questionType == 6">
        题目：
        <div class="top">
          <span v-html="qusetionItem.name"></span>
          <img :src="qusetionItem.attachmentUrl | filterUrl" v-if="qusetionItem.attachmentUrl" />
        </div>
        <div class="bottom">
          <ul class="viewUl">
            <div class="bot_t">
              <li></li>
              <template v-for="item in qusetionItem.questionItems">
                <li v-if="item.itemType == 0" :key="item.id">
                  <span>{{ item.itemTitle }}</span>
                  <img :src="item.itemAttachmentUrl | filterUrl" v-if="item.itemAttachmentUrl" />
                </li>
              </template>
            </div>
            <div class="bot_b">
              <template v-for="item in qusetionItem.questionItems">
                <li v-if="item.itemType == 1" :key="item.id">
                  <span>{{ item.itemTitle }}</span>
                  <span v-for="el in num"><a-radio disabled></a-radio></span>
                </li>
              </template>
            </div>
          </ul>
        </div>
      </div>
      <!-- 填空题 -->
      <div v-if="qusetionItem.questionType == 7">
        题目：
        <div class="top">
          <span v-html="qusetionItem.name"></span>
          <img :src="qusetionItem.attachmentUrl | filterUrl" v-if="qusetionItem.attachmentUrl" />
        </div>
      </div>
    </a-modal>
  </a-card>
</template>

<script>
import xlsx from 'xlsx-js-style'

const columns = [
  {
    title: '题目名称',
    scopedSlots: { customRender: 'name' },
    width: 150,
  },
  {
    title: '题目类型',
    scopedSlots: { customRender: 'type' },
    align: 'center',
  },
  {
    title: '题目分组',
    dataIndex: 'questionGroup',
    align: 'center',
  },
  {
    title: '能力类型',
    dataIndex: 'abilityTypeText',
    align: 'center',
  },
  {
    title: '一级能力',
    dataIndex: 'firstAbilityText',
    align: 'center',
    width: 200,
  },
  {
    title: '二级能力',
    dataIndex: 'secondAbilityText',
    align: 'center',
  },
  { title: '版本', dataIndex: 'version', align: 'center' },
  {
    title: '难度系数',
    dataIndex: 'degreeOfDifficulty',
    align: 'center',
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    align: 'center',
  },
  {
    title: '状态',
    scopedSlots: { customRender: 'status' },
    align: 'center',
  },
  {
    title: '操作',
    key: 'action',
    align: 'center',
    scopedSlots: { customRender: 'action' },
  },
]
export default {
  name: 'Question',
  data() {
    return {
      questionTypeList: [
        { title: '单选题', value: 1 },
        { title: '多选题', value: 2 },
        { title: '量表题', value: 3 },
        // { "title": "矩阵单选", "value": 4 },
        // { "title": "矩阵多选", "value": 5 },
        // { "title": "矩阵量表", "value": 6 },
        { title: '填空题', value: 7 },
        { title: '文件上传', value: 8 },
        { title: '问答题', value: 9 },
      ],
      selectedRowKeys: [],
      DownloadTemplate: process.env.VUE_APP_TEMPLATE_URL + '/template/excel/Question_Import_Template.xlsx',
      isimport: false,
      ispreview: false,
      baseURL: process.env.VUE_APP_API_BASE_URL,
      errorData: [],
      fileList: [],
      file: '',
      loading: true,
      advanced: false,
      istoggleAdvanced: false, //是否显示展开按钮
      dataSource: [],
      columns,
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      options: [],
      selectId: '',
      search: {
        pageIndex: 1,
        pageSize: 10,
        Ablit: [],
        name: undefined,
        questionGroup: '',
        AbilityTypeId: '',
        FirstAbilityId: '',
        SecondAbilityId: '',
        questionType: undefined,
      },
      statusType: '',
      qusetionItem: {},
      num: 0,
      submitloading: false,
    }
  },
  created() {
    this.initSearch()
    this.getList()
    this.abilityTypeSelect(0)
  },
  computed: {
    rowSelection() {
      return {
        onSelect: (record, selected) => {
          if (selected) {
            this.selectedRowKeys.push(record.id)
            this.selectRow.push(record)
          } else {
            this.selectedRowKeys = this.selectedRowKeys.filter((v) => v != record.id)
            this.selectRow = this.selectRow.filter((v) => v.id != record.id)
          }
        },
        onSelectAll: (selected, selectedRows, changeRow) => {
          const ids = changeRow.map((v) => v.id)
          if (selected) {
            this.selectedRowKeys.push(...ids)
            this.selectRow.push(...changeRow)
          } else {
            this.selectedRowKeys = this.selectedRowKeys.filter((v) => !(ids.indexOf(v) != -1))
            this.selectRow = this.selectRow.filter((v) => !(ids.indexOf(v.id) != -1))
          }
        },
        selectedRowKeys: this.selectedRowKeys,
      }
    },
  },
  watch: {
    isimport() {
      if (!this.isimport) {
        this.errorData = []
      }
    },
  },
  methods: {
    initSearch() {
      this.search.pageIndex = Number(this.$route.query.pageIndex) || 1
      this.search.pageSize = Number(this.$route.query.pageSize) || 10
      this.search.questionGroup = this.$route.query.questionGroup
      this.search.questionType = Number(this.$route.query.questionType) || undefined
      this.search.AbilityTypeId = Number(this.$route.query.AbilityTypeId) || undefined
      this.search.FirstAbilityId = Number(this.$route.query.FirstAbilityId) || undefined
      this.search.SecondAbilityId = Number(this.$route.query.SecondAbilityId) || undefined
      this.search.minAge = Number(this.$route.query.minAge) || undefined
      this.search.maxAge = Number(this.$route.query.maxAge) || undefined
      if (this.search.AbilityTypeId) {
        this.selectId = [this.search.AbilityTypeId]
      }
      if (this.search.FirstAbilityId) {
        this.selectId = [this.search.AbilityTypeId, this.search.FirstAbilityId]
      }
      if (this.search.SecondAbilityId) {
        this.selectId = [this.search.AbilityTypeId, this.search.FirstAbilityId, this.search.SecondAbilityId]
      }
    },
    setQuery() {
      const query = {}
      for (const key in this.search) {
        if (this.search[key] && typeof this.search[key] !== 'object') {
          query[key] = this.search[key]
        }
      }
      this.$router.push({ query })
    },
    preview(record) {
      console.log(record)
      this.qusetionItem = record
      this.ispreview = true
      this.num = record.questionItems.filter((item) => {
        return item.itemType == 0
      })
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    beforeUpload(file) {
      const bool = this.fileList.filter((v) => v.name === file.name).length
      if (bool) {
        this.$message.warning('已有相同的文件，请重新选择文件')
        return false
      }
      this.fileList = [file]
      return false
    },
    unploadChange(value) {
      if (value.fileList.length) {
        this.file = value.file
      } else {
        this.file = ''
      }
    },
    openModal() {
      this.isimport = true
    },
    cancelSubmit() {
      this.isimport = false
      this.errorData = []
    },
    submit() {
      if (this.file) {
        this.submitloading = true
        const formData = new FormData()
        formData.append('excelfile', this.file)
        this.upload(formData)
      } else {
        this.$message.destroy()
        this.$message.warning('请选择xlsx文件')
      }
    },
    upload(formData) {
      this.$http
        .questionsImport(formData)
        .then((res) => {
          this.$message.success(res.message)
          this.isimport = false
          this.fileList = []
          this.file = ''
          this.getList()
          this.resetForm()
        })
        .catch((e) => {
          if (e.errors) {
            this.errorData = e.errors
            this.getList()
          }
        })
        .finally(() => {
          this.submitloading = false
        })
    },
    // 下载错误原因
    down() {
      const merges = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 10 } }]
      let titleList1 = ['题目', '', '', '', '', '', '', '', '', '', '']
      let titleList2 = ['题目名称', '题目分组', '题目类型', '题目版本', '题目难度系数', '题目能力类型', '题目一级能力', '题目二级能力', '题目备注说明', '题目解析', '题目附件']
      const list = this.errorData.map((m, i) => {
        let data = [
          m.name,
          m.questionGroup,
          this.$data._questionType[m.questionType],
          m.version,
          m.degreeOfDifficultyText,
          m.abilityTopText,
          m.firstAbilityText,
          m.secondAbilityText,
          m.remark,
          m.analysis,
          m.attachmentUrl,
        ]
        m.questionItems.forEach((f, i2) => {
          data = data.concat([f.itemTitle, f.scoreText, f.isRightChoiceText, f.displayOrderText, f.jumpQuestionNOText, f.itemAttachmentUrl])
          if (i === 0) {
            merges.push({ s: { r: 0, c: 10 + i2 * 6 + 1 }, e: { r: 0, c: 10 + (i2 + 1) * 6 } })
            titleList1 = titleList1.concat(['选项' + (i2 + 1), '', '', '', '', ''])
            titleList2 = titleList2.concat(['选项标题', '选项分值', '是否正确答案', '显示顺序', '跳转题目编号', '选项附件'])
          }
        })
        data.push(m.messageList.join('\n'))
        return data
      })
      // 添加错误信息列
      titleList1.push('错误信息')
      titleList2.push('')
      merges.push({ s: { r: 0, c: titleList2.length - 1 }, e: { r: 1, c: titleList2.length - 1 } })
      // 创建一个新的工作簿
      const workbook = xlsx.utils.book_new()
      // 将数据转换为工作表
      const worksheet = xlsx.utils.aoa_to_sheet([titleList1, titleList2].concat(list))
      const cols = []
      // 设置内容样式
      Object.keys(worksheet).forEach((f) => {
        if (typeof worksheet[f] !== 'object') {
          return
        }
        worksheet[f].s = {
          font: {
            sz: 12,
            color: { rgb: '000000' },
          },
          alignment: {
            horizontal: 'center',
            vertical: 'center',
          },
        }
      })
      // 设置表头样式
      titleList2.forEach((f, i) => {
        const ex0 = xlsx.utils.encode_cell({ r: 0, c: i })
        const ex1 = xlsx.utils.encode_cell({ r: 1, c: i })
        const obj = {
          font: {
            sz: 12,
            bold: true,
            color: { rgb: worksheet[ex0].v === '错误信息' ? 'FF0000' : '000000' },
          },
          fill: {
            fgColor: { rgb: 'eeeeeeff' }, // 背景
          },
          border: {
            top: { style: 'thin', color: { rgb: '000000' } }, // 上边框
            bottom: { style: 'thin', color: { rgb: '000000' } }, // 下边框
            left: { style: 'thin', color: { rgb: '000000' } }, // 左边框
            right: { style: 'thin', color: { rgb: '000000' } }, // 右边框
          },
          alignment: {
            horizontal: 'center',
            vertical: 'center',
          },
        }
        worksheet[ex0].s = obj
        worksheet[ex1].s = obj
        // 设置列宽
        cols.push({ wpx: worksheet[ex0].v === '错误信息' ? 250 : 120 })
      })
      // 设置列宽
      worksheet['!cols'] = cols
      // 设置行高
      worksheet['!rows'] = list.map((m) => ({ hpt: 23 }))
      // 设置合并单元格
      worksheet['!merges'] = merges
      // 将工作表添加到工作簿中
      xlsx.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
      // 将工作簿导出为 Excel 文件
      xlsx.writeFile(workbook, '导入题目错误数据.xlsx')
    },
    StatusChange(record) {
      let formData = new FormData()
      formData.append('id', record.id)
      this.$http.questionsUpdatestatus(formData).then((res) => {
        console.log(res)
        this.$message.destroy()
        record.status = !record.status
        this.$message.success('修改成功')
        this.loading = false
      })
    },
    onChange(value) {
      console.log(value)
      this.search.AbilityTypeId = value[0]
      this.search.FirstAbilityId = value[1]
      this.search.SecondAbilityId = value[2]
      this.selectId = value
    },
    loadData(selectedOptions) {
      return new Promise((resolve, reject) => {
        const targetOption = selectedOptions[selectedOptions.length - 1]
        targetOption.loading = true
        targetOption.children = []
        let params = {
          pid: targetOption.id,
          abilityType: 0,
        }
        this.$http.abilitySelect(params).then((res) => {
          targetOption.loading = false
          targetOption.children = res.data.data.map((m) => ({ ...m, value: m.id, label: m.name, isLeaf: m.levelNumber > 1 }))
          this.options = [...this.options]
          resolve(targetOption.children)
        })
      })
    },
    abilityTypeSelect(level) {
      let params = {
        level: level,
      }
      this.$http.abilitySelect(params).then((res) => {
        this.options = res.data.data
        this.options.forEach((item) => {
          item.value = item.id
          item.label = item.name
          item.isLeaf = false
        })
        // 排序
        this.options.sort((a, b) => {
          return a.abilityType - b.abilityType
        })
        let arr = []
        let arr2 = []
        this.options.forEach((item, index) => {
          item.value = item.id
          item.label = item.name
          item.isLeaf = false
          if (item.abilityType == 0) {
            arr.push(index)
            arr.sort((a, b) => {
              return a - b
            })
          }
          if (item.abilityType == 1) {
            arr2.push(index)
            arr2.sort((a, b) => {
              return a - b
            })
          }
        })
        let str = {
          label: '通用能力',
          name: '通用能力',
          disabled: true,
          value: '通用能力',
        }
        let str2 = {
          label: '题目能力',
          name: '题目能力',
          disabled: true,
          value: '题目能力',
        }
        this.options.splice(arr[0], 0, str)
        this.options.splice(arr2[0] + 1, 0, str2)
        if (this.search.AbilityTypeId) {
          this.loadData(this.options.filter((f) => f.id === this.search.AbilityTypeId)).then((data) => {
            if (this.search.FirstAbilityId) {
              this.loadData(data.filter((f) => f.id === this.search.FirstAbilityId))
            }
          })
        }
      })
    },
    addEgame() {
      this.$store.commit('content/setQuestionInfo', { routerName: '题目管理', fullPath: this.$route.fullPath })
      this.$router.push({
        path: '/content/Question/QuestionSeting',
        query: {
          type: 'add',
        },
      })
    },
    edit(record) {
      this.$store.commit('content/setQuestionInfo', { routerName: '题目管理', fullPath: this.$route.fullPath, ...record })
      sessionStorage.setItem('editquestion', record.id)
      sessionStorage.removeItem('editquestionModal')
      this.$router.push({
        path: '/content/Question/QuestionSeting',
        query: {
          id: record.id,
        },
      })
    },
    betchDel() {
      if (!this.selectedRowKeys.length) {
        return this.$message.error('请选择题目')
      }
      this.$confirm({
        title: '确认删除所选题目?',
        onOk: () => {
          this.delQuestion(this.selectedRowKeys, true)
        },
      })
    },
    delQuestion(ids, betch = false) {
      const form = new FormData()
      ids.forEach((id) => form.append('ids', id))
      this.loading = true
      this.$http
        .questionsDelete(form)
        .then((res) => {
          this.$message.success(res.message)
          this.selectedRowKeys = []
          this.selectRow = []
          this.getList(1)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getList(num) {
      if (num) {
        this.search.pageIndex = 1
      }
      this.setQuery()
      this.$http
        .questionsList(this.search)
        .then((res) => {
          this.dataSource = res.data.data.items
          this.total = res.data.data.totalCount
        })
        .finally(() => {
          this.loading = false
        })
    },
    getVersion(expanded, record) {
      if (expanded) {
        let params = {
          id: record.contentId,
        }
        this.$http.EGamegeVersion(params).then((res) => {
          console.log(res)
          this.innerData = res.data.data
        })
      }
    },
    onPageChange(pageIndex, size) {
      this.search.pageIndex = pageIndex
      this.getList()
    },
    onSizeChange(pageIndex, size) {
      this.search.pageIndex = 1
      this.search.pageSize = size
      this.getList()
    },
    resetSearch() {
      this.search = {
        pageIndex: 1,
        pageSize: 10,
        Ablit: [],
        questionGroup: '',
        AbilityTypeId: '',
        FirstAbilityId: '',
        SecondAbilityId: '',
        questionType: undefined,
        name: undefined,
      }
      this.selectId = []
      this.getList()
    },
  },
}
</script>

<style scoped>
.Question >>> .standard-table .alert {
  display: none !important;
}

.Question >>> .searchForm {
  display: flex;
}
.Question >>> .searchForm .fold {
  width: 91%;
  display: flex;
}
</style>
<style scoped lang="less">
.top {
  input {
    outline: none !important;
  }
  img {
    width: 120px;
  }
}
.bottom {
  margin-top: 10px;
}
.viewUl {
  padding: 0;
  border: 1px solid #e6e6e6;
  border-top: 0;
  li {
    list-style: none;
    border-top: 1px solid #e6e6e6;
    display: flex;
    align-items: center;
    padding: 5px 15px;
    min-height: 53px;
    span {
      margin: 0 30px;
    }
    img {
      margin-left: 100px;
      width: 100px;
    }
  }
  .viewpick {
    background: #f2f2f2;
  }
  .bot_t {
    display: flex;
    background: #f2f2f2;
    li {
      flex: 1 1 0;
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      border-right: 1px solid #e6e6e6;
      min-height: 53px;
      span {
        margin: 0;
      }
    }
    li:last-child {
      border-right: 0;
    }
  }
  .bot_b {
    li {
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 53px;
      span {
        min-height: 53px;
        display: flex;
        margin: 0;
        flex: 1 1 0;
        justify-content: center;
        align-items: center;
        border-right: 1px solid #e6e6e6;
      }
      span:last-child {
        border-right: 0;
      }
    }
  }
}
.name {
  width: 150px;
  height: 21px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.name /deep/ * {
  margin: 0;
  padding: 0;
  font-size: 14px !important;
}

/deep/ .ant-cascader-menu-item-disabled {
  cursor: default;
}
</style>
